export default "__VITE_ASSET__lEEsQVV1__"